import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import config from '../../../config';

export default function EmailCode() {
    const [code, setCode] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLoginSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${config.API_BASE_URL_V1}forgot-password/verify-reset-code`, {
                code: parseInt(code),
                email: location.state?.email,
            });
            if(response.data.status === 'success')
            {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Success",
                    showConfirmButton: false,
                    timer: 1500,
                });
                navigate('/dashboard-reset-password', { state: { email: location.state?.email, code: parseInt(code) } });
            }
            else
            {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Try again later",
                    showConfirmButton: true,
                });
            }
        } catch (err) {
            console.error('Error:', err); // Hatanın detayını görmek için konsola yazdır
            setError(err.response?.data?.message || 'An error occurred. Please try again.');
        }finally {
            setLoading(false);
        }
        
    };

    return (
        <div className="main-wrapper authentication-wrapper">
            <div className="auth-bg-overlay">
                <div className="auth-container">
                    <div className="auth-content">
                        <div className="auth-card">
                            {/* Left Side - Form */}
                            <div className="auth-form-side">
                                <div className="logo-container">
                                    <img src="/assets/logo-1.png" className="floating-logo" alt="logo-img"/>
                                </div>
                                <div className="auth-form-header">
                                    <h4>Enter Verification Code</h4>
                                    <p>Please enter the code sent to your email</p>
                                </div>

                                <form onSubmit={handleLoginSubmit} className="auth-form">
                                    <div className="form-group">
                                        <div className="input-icon">
                                            <span className="input-icon-addon">
                                                <i className="isax isax-key"></i>
                                            </span>
                                            <input 
                                                type="text" 
                                                required 
                                                className="form-control form-control-lg" 
                                                value={code} 
                                                onChange={(e) => setCode(e.target.value)} 
                                                placeholder="Enter verification code" 
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <button 
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary btn-lg btn-block"
                                        >
                                            {loading ? 'Verifying...' : 'Verify Code'}
                                        </button>
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger">
                                            {error}
                                        </div>
                                    )}
                                </form>
                            </div>

                            {/* Right Side - Welcome Content */}
                            <div className="auth-welcome-side">
                                <div className="welcome-content">
                                    <div className="welcome-card main-card">
                                        <h2>Email Verification</h2>
                                        <p>Secure Account Recovery Process</p>
                                    </div>
                                    <div className="feature-list">
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-key"></i>
                                            </div>
                                            <p>Enter Verification Code</p>
                                        </div>
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-shield"></i>
                                            </div>
                                            <p>Verify Your Identity</p>
                                        </div>
                                        <div className="feature-card">
                                            <div className="feature-icon">
                                                <i className="isax isax-lock"></i>
                                            </div>
                                            <p>Reset Your Password</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="copyright-footer">
                <p>Copyright &copy; {new Date().getFullYear()}. All Rights Reserved, 
                    <a href="https://cornleth.com">Cornleth</a>
                </p>
            </div>

            {/* Add the same styles as ForgotPassword.jsx */}
            <style>{`
                // ... copy all styles from ForgotPassword.jsx ...
            `}</style>
        </div>
    );
}
